import { Box, Card, CardContent, Divider, Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { CellFrame, Organism } from '@/core/architecture'

export const OrderItemDetailSkeleton: Organism = () => (
  <CellFrame sx={{ pb: 5 }}>
    <Box sx={{ py: 2 }}>
      <SkeletonText variant="h3" width="50%" />
    </Box>
    <Card elevation={0} sx={{ borderRadius: 2 }}>
      <CardContent sx={{ px: 5, py: 4, '&:last-child': { pb: 4 } }}>
        <SkeletonText variant="small" width="50%" />
        <Stack spacing={5}>
          <Stack direction="row" sx={{ pt: 5 }} spacing={3}>
            <Skeleton variant="rectangular" width={60} height={96} />
            <Stack flex={1}>
              <SkeletonText variant="h3" />
              <SkeletonText variant="small" sx={{ mt: 2 }} />
              <SkeletonText variant="medium" width="40%" sx={{ mt: 2 }} />
            </Stack>
          </Stack>
          <Divider />
          <Stack direction="row" justifyContent="space-between">
            <Stack width="30%">
              <SkeletonText variant="h3" />
            </Stack>
            <Stack width="30%">
              <SkeletonText variant="h3" />
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  </CellFrame>
)
